// Generic error landing page for the IAS deployment. `AppSsoProvider` pushes
// users here with `?error=` and `?description=` query params when the OIDC
// exchange throws a non-403 (auth error, network failure, etc). Renders the
// upstream `GenericError` component with those params surfaced as the title
// and message.

import { GenericError } from "metabase/common/components/ErrorPages";

export const IasErrorPage = (): JSX.Element => {
  const params = new URLSearchParams(location.search);
  const error = params.get("error") ?? undefined;
  const description = params.get("description") ?? undefined;
  return <GenericError title={description} message={error} details={null} />;
};
